import { ESdChangeReason, IActionFolder } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { getSdInstance } from "../../../../shared/utility/designer-context";
import {
  createDesignerFolder,
  createDesignerSubfolder,
  renameDesignerFolder,
  renameDesignerSubfolder
} from "../../../../shared/utility/designer-folder-actions";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import FolderModal from "../../../common/folder-modal";

export interface IFolderCreateComponentState {
  formData: IActionFolder;
}

export interface IFolderCreateComponentProps {
  showModal?: boolean;
  closeModal?: () => void;
  showEditModal?: boolean;
  closeEditModal?: () => void;
  editingFolderId?: string;
  editingFolderName?: string;
  dataSourceType?: string;
  folderParentFolderId?: string | undefined | null;
}

class FolderCreateComponent extends PureSdComponent<
  IFolderCreateComponentProps & IWithSDProps,
  IFolderCreateComponentState
> {
  constructor(props: IFolderCreateComponentProps & IWithSDProps) {
    super(props);
    const folders = {} as IActionFolder;
    this.state = {
      formData: folders
    };
  }

  onSubmit = async (data: { name: string }): Promise<boolean> => {
    try {
      const folderNameRules = /^[A-Za-z][A-Za-z0-9 ]+$/;
      const isFolderNameValid = folderNameRules.test(data.name);
      if (!isFolderNameValid) {
        KMainFunctions.displayWarningNotification("Folder Name is invalid");
        return false;
      }
      if (this.props.showEditModal) {
        this.handleEditFolder(data);
        return true;
      }
      this.handleAddFolder(data);
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  };

  /** An action folder, top level or nested. Table folders are not offered: the project does not save them. */
  handleAddFolder = (data: { name: string }) => {
    if (this.props.folderParentFolderId) {
      this.handleAddFolderInFolder(data);
      return;
    }
    if (this.props.dataSourceType) {
      createDesignerFolder(getSdInstance(), {
        folderType: "action",
        folderName: data.name,
        dataSourceType: this.props.dataSourceType
      });
    }
  };

  handleEditFolder = (data: { name: string }) => {
    if (this.props.editingFolderId) {
      if (!this.props.folderParentFolderId) {
        renameDesignerFolder(getSdInstance(), {
          folderType: "action",
          folderId: this.props.editingFolderId,
          folderName: data.name
        });
      } else {
        this.handleEditFolderInFolder(data);
      }
    }
  };

  handleAddFolderInFolder = (data: { name: string }) => {
    if (this.props.folderParentFolderId) {
      createDesignerSubfolder(getSdInstance(), {
        folderType: "action",
        parentFolderId: this.props.folderParentFolderId,
        folderName: data.name
      });
    }
  };

  handleEditFolderInFolder = (data: { name: string }) => {
    if (this.props.editingFolderId) {
      const parentFolderId = this.props.folderParentFolderId;
      if (parentFolderId) {
        renameDesignerSubfolder(getSdInstance(), {
          folderType: "action",
          parentFolderId,
          subFolderId: this.props.editingFolderId,
          folderName: data.name
        });
      }
    }
  };

  render() {
    return (
      <FolderModal
        showModal={this.props.showModal}
        closeModal={this.props.closeModal}
        showEditModal={this.props.showEditModal}
        closeEditModal={this.props.closeEditModal}
        editingFolderId={this.props.editingFolderId}
        editingFolderName={this.props.editingFolderName}
        onSubmit={this.onSubmit}
        folderType="diagram"
      />
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const folderCreateComponent = withSD<IFolderCreateComponentProps>(FolderCreateComponent);
export { folderCreateComponent as FolderCreateComponent };
